import {
    HubModuleType,
    ICreateRichTextHubModuleDTO,
    IRichTextHubModuleDTO,
} from '../../../../../../../../api/event-hubs.dao';
import {
    CONTENT,
    DISPLAY_LABEL,
    LABEL,
    POSITION_ORDER,
    RICH_TEXT_MODULE_CONFIG,
} from './rich-text-module.config';
import { HubModuleVM } from '../hub-module.viewmodel';
import { transpileClassesToInlineStyles, transpileInlineStylesToClasses } from '../../../../../../../global/rich-text-editor/utils/transpiler';

export class RichTextModuleVM extends HubModuleVM {
    public static createEmpty(positionOrder: number): RichTextModuleVM {
        return new RichTextModuleVM({ positionOrder: positionOrder });
    }

    public static createFromDTO(dto: IRichTextHubModuleDTO | ICreateRichTextHubModuleDTO): RichTextModuleVM {
        const transpiledContent = transpileInlineStylesToClasses(dto.content);
        return new RichTextModuleVM({ ...dto, content: transpiledContent });
    }

    private constructor(module: Partial<IRichTextHubModuleDTO>) {
        super(module.moduleId, 'RichTextModuleVM', RICH_TEXT_MODULE_CONFIG, module);
        this.savedSnapshot = this.serialize();
    }

    public getModuleType = (): HubModuleType => {
        return HubModuleType.RICH_TEXT;
    };

    public clone = (): RichTextModuleVM => {
        const dto = this.isNew() ? this.toCreateDTO() : this.toUpdateDTO() as IRichTextHubModuleDTO;
        const vm = RichTextModuleVM.createFromDTO(dto);
        this.copyIdentityTo(vm);
        return vm;
    };

    public isValid = (): boolean => {
        return this.isVmValid();
    };

    public toCreateDTO = (): ICreateRichTextHubModuleDTO => {
        const content = this.getTrimmedStringValue(CONTENT);
        const transpiledContent = transpileClassesToInlineStyles(content);

        return {
            positionOrder: this.getNumberValue(POSITION_ORDER),
            moduleType: HubModuleType.RICH_TEXT,
            enabled: this.isEnabled(),
            label: this.getTrimmedStringValue(LABEL),
            displayLabel: this.getBooleanValue(DISPLAY_LABEL),
            content: transpiledContent,
        };
    };
}
